<template>
  <div class="modal-cookie-block">
    <div class="modal-cookie-block_header">
      <div
        class="modal-cookie-block_title"
        @click="toggleBlock"
      >
        <svg v-if="!showBlock" class="modal-cookie-block_icon -append" width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_6399_14005)">
            <path d="M13.25 13.25V7C13.25 6.44772 13.6977 6 14.25 6H14.6667C15.219 6 15.6667 6.44772 15.6667 7V13.25H21.9167C22.469 13.25 22.9167 13.6977 22.9167 14.25V14.6667C22.9167 15.219 22.469 15.6667 21.9167 15.6667H15.6667V21.9167C15.6667 22.469 15.219 22.9167 14.6667 22.9167H14.25C13.6977 22.9167 13.25 22.469 13.25 21.9167V15.6667H7C6.44772 15.6667 6 15.219 6 14.6667V14.25C6 13.6977 6.44772 13.25 7 13.25H13.25Z" fill="#203454"/>
          </g>
          <defs>
            <clipPath id="clip0_6399_14005">
              <rect width="29" height="29" fill="white"/>
            </clipPath>
          </defs>
        </svg>

        <svg v-else class="modal-cookie-block_icon -append" width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_6420_7574)">
            <path d="M13.292 13.292H15.7087H21.9587C22.5109 13.292 22.9587 13.7397 22.9587 14.292V14.7087C22.9587 15.2609 22.5109 15.7087 21.9587 15.7087H15.7087H13.292H7.04199C6.48971 15.7087 6.04199 15.2609 6.04199 14.7087V14.292C6.04199 13.7397 6.48971 13.292 7.04199 13.292H13.292Z" fill="#203454"/>
          </g>
          <defs>
            <clipPath id="clip0_6420_7574">
              <rect width="29" height="29" fill="white"/>
            </clipPath>
          </defs>
        </svg>

        {{ cookie.title }}
      </div>

      <ac-switch
        :model-value="cookie.enabled"
        @click="toggleCookie(cookie.key)"
      >
        <template v-if="cookie.key === 'essential'" #icon>
          <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.59392 8.31818H9.66294V6.27273C9.66294 5.51989 9.41543 4.87713 8.92041 4.34446C8.42539 3.81179 7.82806 3.54545 7.12843 3.54545C6.4288 3.54545 5.83147 3.81179 5.33645 4.34446C4.84143 4.87713 4.59392 5.51989 4.59392 6.27273V8.31818ZM12.8311 9.34091V15.4773C12.8311 15.7614 12.7387 16.0028 12.5539 16.2017C12.3691 16.4006 12.1446 16.5 11.8806 16.5H2.37622C2.11221 16.5 1.8878 16.4006 1.70299 16.2017C1.51819 16.0028 1.42578 15.7614 1.42578 15.4773V9.34091C1.42578 9.05682 1.51819 8.81534 1.70299 8.61648C1.8878 8.41761 2.11221 8.31818 2.37622 8.31818H2.69304V6.27273C2.69304 4.96591 3.12866 3.84375 3.99989 2.90625C4.87113 1.96875 5.91398 1.5 7.12843 1.5C8.34288 1.5 9.38573 1.96875 10.257 2.90625C11.1282 3.84375 11.5638 4.96591 11.5638 6.27273V8.31818H11.8806C12.1446 8.31818 12.3691 8.41761 12.5539 8.61648C12.7387 8.81534 12.8311 9.05682 12.8311 9.34091Z" fill="#51DA3B"/>
          </svg>
        </template>
      </ac-switch>
    </div>

    <div class="modal-cookie-block_body">
      <div v-if="false" class="">
        <!-- TODO Этот текст заменить потом когда будет описание -->
        Разнообразный и богатый опыт постоянный количественный рост и сфера нашей активности представляет собой интересный эксперимент проверки модели развития. Таким образом постоянный количественный рост.
      </div>
      <div v-show="showBlock" class="modal-cookie-block_hidden">
        <div
          v-for="(item, key) in cookie.items"
          :key="`modal-cookie-block_item-${key}`"
          class="modal-cookie-block_item item"
        >
          <div class="item_row">
            <div class="item_title">{{ $t('cookie.name') }}</div>
            <div class="item_desc">{{ item.names.join(', ') }}</div>
          </div>

          <div v-if="item.type" class="item_row">
            <div class="item_title">{{ $t('cookie.type') }}</div>
            <div class="item_desc">{{ item.type }}</div>
          </div>

          <div class="item_row">
            <div class="item_title">{{ $t('cookie.description') }}</div>
            <div class="item_desc">{{ item.title }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, ref } from 'vue'
import AcSwitch from '@ui-kit/components/AcSwitch.vue'

export default defineComponent({
  name: 'AcCookieModalBlock',
  components: {
    AcSwitch
  },
  props: {
    cookie: {
      type: Object as PropType<Cookies>,
      default: () => ({})
    }
  },
  emits: ['toggle'],
  setup (props, ctx) {
    const showBlock = ref(false)

    function toggleCookie (type: 'essential' | 'analytics' | 'marketing') {
      ctx.emit('toggle', type)
    }

    function toggleBlock () {
      showBlock.value = !showBlock.value
    }

    return {
      showBlock,
      toggleCookie,
      toggleBlock
    }
  }
})
</script>

<style lang="scss" scoped>
.modal-cookie-block {
  padding: 12px 0;
  border-bottom: 1px solid #D9D9D9;

  &:last-child {
    border-bottom: 0;
  }

  &_header {
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 140%;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
  }

  &_title {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: flex-start;
    cursor: pointer;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 140%;

    @media (max-width: 500px) {
      font-size: 16px;
      font-weight: 600;
    }
  }

  &_icon {
    &.-append {
      margin-right: 14px;
      cursor: pointer;
    }
  }

  &_body {}

  &_hidden {
    margin-top: 12px;
  }
}

.item {
  padding: 10px;
  border-radius: 8px;
  background-color: #EFF5FE;
  margin-top: 12px;
  display: grid;
  grid-auto-flow: row;

  &_row {
    display: grid;
    grid-auto-flow: column;
    grid-template-columns: 110px auto;
    margin-bottom: 16px;
    align-items: baseline;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &_title {
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 140%;

    @media (max-width: 500px) {
      font-size: 14px;
      font-weight: 700;
    }
  }
  &_desc {
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 130%;
    overflow-wrap: anywhere;

    @media (max-width: 500px) {
      font-size: 12px;
    }
  }
}
</style>
